export const saveLoginSession = (response, setPersist) => {
  // A new login replaces the previous account, including its guest marker.
  setPersist("user_info", response.player_info);
  setPersist("abtest_tag", response.player_info.abtest_tag);
  setPersist("gatesvr", response.gatesvr);
};

export const refreshPlayerInfo = (playerInfo, previousInfo) => {
  if (
    playerInfo.is_guest === undefined &&
    previousInfo &&
    previousInfo.is_guest !== undefined &&
    playerInfo.rid !== undefined &&
    previousInfo.rid !== undefined &&
    String(playerInfo.rid) === String(previousInfo.rid)
  ) {
    return { ...playerInfo, is_guest: previousInfo.is_guest };
  }
  return playerInfo;
};
